import { e } from "./engine-user-agent.js";
var i = /ipad|iphone|ipod/i.test(e) && "undefined" != typeof Pebble;
export { i as e };